export default function priceDisplayValue (val) {
  if (!val) {
    return '0';
  }
  return val.toFixed(2);
}
